import React, { Component } from "react";
import axios from "axios";
import { apiUrl } from "../../config/config";
import classnames from "classnames";
import $ from "jquery";
import socketIOClient from "socket.io-client";
import { MDBDataTable } from "mdbreact";
import ProgressBtn from "../../components/common/ProgressButton";
import TopNav from "../../components/common/TopNav";
import SideBar from "../../components/common/SideBar";
import { livePatientsEnabled } from "../../config/config";
import AddModalComplete from "../verifier/AddModalComplete";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import Select from "react-select";
import AddModalReport from "./AddModalReport";
import { format, parseISO } from "date-fns";
import "./patient-list.css";

import LinearProgress from "@material-ui/core/LinearProgress";
// eslint-disable-next-line import/no-webpack-loader-syntax
import Worker from "worker-loader!./worker.js";
import { duration } from "@material-ui/core";
import { Pointer, time } from "highcharts";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import { ColumnSizing } from "@tanstack/react-table";
import url from "socket.io-client/lib/url";
import { Toaster, toast } from "react-hot-toast";

// Live progress socket disabled — re-enable once the backend at
// https://web.mybiocalculus.com:5000 has CORS configured for cross-origin
// credentialed requests. ProgressButton handles socket === null gracefully.
// const socket = socketIOClient("https://web.mybiocalculus.com:5000");
const socket = null;

const customStyles = {
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: "10px",
    position: "relative",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "100%",
    opacity: 0.4,
    borderRadius: 4,
  },
};
class Patienthold extends Component {
  constructor() {
    super();
       const menus = [
         { title: "Verifier Home", url: "/verifier-home" },
         { title: "Patient list", url: "/patient-list" },
         { title: "Labled Patients", url: "/labled-patients" },
         { title: "Verified", url: "/verification-completed" },
   
       ];
       if (localStorage.getItem("verifiertype") === "8") {
         menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
       }
        if (localStorage.getItem("AdminUser") === "8") {
          menus.splice(3, 0, { title: "Device Details", url: "/device-details" });
          menus.splice(4, 0, { title: "Battery Issue", url: "/battery-issue" });
        }
   
       if (localStorage.getItem("verifiertype") === "8") {
         menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
       }
       if (localStorage.getItem("verifiertype") === "8") {
         menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
       }
       if (localStorage.getItem("AdminUser") === "8") {
         menus.splice(6, 0, { title: "Report Shared", url: "/report-shared" });
       }
       if (localStorage.getItem("AdminUser") === "8") {
         menus.splice(6, 0, {
           title: "Supported Person",
           url: "/supported-persons",
         });

         }
          if (localStorage.getItem("AdminUser") === "8") {
           menus.splice(6, 0, {
             title: "Reset Password",
             url: "/ResetPassword",
           });
       }
    this.state = {
      menus,
      isModalCompleteOpen: false,
      profileLink: "verifier-profile",
      patients: [],
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      macid: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
      errors: {},
      userid: "",
      smoking: "",
      diabetes: "",
      height: "",
      weight: "",
      hospital: "",
      phone: "",
      patient_name: "",
      email_id: "",
      dob: null,
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      thyroid_function: "",
      cardiac_surgery: "",
      doctors: [],
      verifiers: [],
      selectedVerifierIds: [],
      selectedVerifiers: [],
      doctor_id: "",
      doctor_name: "Choose",
      doctors: [],
      selectedDoctor: null,
      searchTerm: "",
      data: {},
      prog_data: 0,
      loading: false,
      // socketNew: socket,
      patientDetails: null,
      ipop: "",
      priority: "",
      verifiertype: "",
      allverifiers: "",
      reportstatus: "",
      isModalReportOpen: false,
      generatereportuserid: "",
      treemenu: [],
      duration: "",
      customer_details: "",
      showButton: true,
      refreshKey: 0,
      filetype: "",
      sortedPatients: [],
      selectedVerifiersEfficency: [],
      hourstocompleted: "",
      gender: "",
      columns: [],
      rows: [],
      searchQuery: "",
      pacemaker: false,
      issueReport: "",
      Confirmation: "",
      isConfirmationModalOpen: false,
      selectedConfirmation: "",
      loadingEditModal: false, // Add loading state for edit modal
      prioritizeData: "No", // <-- Add this line for the new field
      clinicalCondition: "", // <-- Add this line for the new field
      newComment: "", // new comment being typed (separate from existing comments history)
    };
    this.intervalId = null;

    this.selectItem = this.selectItem.bind(this);
    this.getInfo = this.getInfo.bind(this);
    this.handleModalComplete = this.handleModalComplete.bind(this);

    this.submitComment = this.submitComment.bind(this);
    this.preventDefault = this.preventDefault.bind(this);
    this.getConfirmTime = this.getConfirmTime.bind(this);
    this.HandleVerifiedSpeed = this.HandleVerifiedSpeed.bind(this);
    this.getverifiedprogress = this.getverifiedprogress.bind(this);
    this.onGenderChange = this.onGenderChange.bind(this);
    this.filterRows = this.filterRows.bind(this);
    this.confirmPatient = this.confirmPatient.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
  }
  componentDidMount() {
    // Fetch data initially
    this.fetchData();

    // Set an interval to check the condition and fetch data
    this.intervalId = setInterval(() => {
      if (!this.state.isModalCompleteOpen) {
        this.fetchData();
      } else {
        console.log("Modal is open, skipping data refresh");
      }
    }, 30000); // 30 seconds
  }

  componentWillUnmount() {
    // Clear the interval when the component unmounts
    clearInterval(this.intervalId);
  }

  fetchData = () => {
    const verifiertype = localStorage.getItem("verifiertype");
    this.setState({ verifiertype });

    const worker = new Worker();

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

    var newstat = this;

    worker.postMessage({
      name: "alldoctors",
      url: apiUrl + "api/users/alldoctors",
    });

    worker.addEventListener("message", function (event) {
      newstat.setState({ doctors: event.data });
    });

    axios
      .all([
        axios.get(apiUrl + "api/users/GetHoldPatients"),
        axios.get(apiUrl + "api/users/allverifiers"),
      ])
      .then(
        axios.spread((patientsRes, verifiersRes) => {
          const filteredPatients = patientsRes.data.sortedPatients.filter(
            (patient) => patient.Confirmation === "Hold"
          );

          this.setState(
            {
              patients: filteredPatients,
              allverifiers: verifiersRes.data,
            },
            () => {
              // Sorting logic remains unchanged
              const sortedPatients = this.state.patients.sort((a, b) => {
                // Determine priority for each patient (default to 4 if not defined)
                const priorityA =
                  a.deviceInfo && a.deviceInfo.priority !== undefined
                    ? a.deviceInfo.priority
                    : 4;
                const priorityB =
                  b.deviceInfo && b.deviceInfo.priority !== undefined
                    ? b.deviceInfo.priority
                    : 4;

                // First, compare priorities (ascending order)
                if (priorityA !== priorityB) {
                  return priorityA - priorityB;
                }

                // If priorities are the same, compare updateddate (descending order)
                const updatedDateA = new Date(a.updateddate);
                const updatedDateB = new Date(b.updateddate);

                // Return descending order comparison of updateddate
                return updatedDateB - updatedDateA;
              });

              // console.log('percentage',patientsWithPercentages);  // Log the updated patients array with percentage

              const data = {
                columns: [
                  { label: "SL", field: "slno", sort: "asc" },
                  { label: "PATIENT", field: "patient", sort: "asc" },
                  { label: "ADDED DATE", field: "added_date", sort: "asc" },
                  { label: "DISTRIBUTOR", field: "distributor", sort: "disabled" },
                  { label: "DOCTOR NAME", field: "doctor_name", sort: "asc" },
                  { label: "ACTION", field: "action", sort: "disabled" },
                  ...(this.state.verifiertype === "8"
                    ? [{ label: "REPORT", field: "report", sort: "disabled" }]
                    : []),
                  { label: "MONITORING", field: "monitoring_duration", sort: "disabled" },
                ],
                rows: [],
              };

              sortedPatients.forEach((patient, i) => {
                const Priority =
                  (patient.deviceInfo && patient.deviceInfo.Priority) || 4; // Set Priority value

                // Variable to store the final time value
                let finalTime;

                // Ensure the date fields are not undefined or null before splitting
                if (patient.ConfirmupdatedDate) {
                  // Split the 'ConfirmupdatedDate' by 'T' to get the date and time parts
                  let confirmButtonTime = patient.ConfirmupdatedDate.split("T");

                  // Get the date part before 'T'
                  let confirmDate = confirmButtonTime[0]; // '2024-11-29'

                  // Get the time part after 'T'
                  let confirmTime = confirmButtonTime[1]
                    ? confirmButtonTime[1].split("Z")[0] // Remove 'Z' if it exists
                    : ""; // If no time part, default to an empty string

                  // Handle removing milliseconds (if any) from confirmTime
                  if (confirmTime) {
                    let time = confirmTime.split(".")[0]; // Get time without milliseconds
                    const confirmbtnTime = confirmDate + " " + time; // Add a space between date and time
                    // console.log("Confirm button time:", confirmbtnTime);

                    // Assign confirmbtnTime to finalTime if available
                    finalTime = confirmbtnTime;
                  } else {
                    // console.log("Confirm Time is empty or invalid");
                  }
                } else {
                  // console.log("ConfirmupdatedDate is undefined or null");
                }

                // Check and split the 'updatedDate' if it's available
                if (patient.updatedDate) {
                  // Split the 'updatedDate' by space to separate date and time
                  let updatedDateTime = patient.updatedDate.split(" ");

                  // Get the date part before the space
                  let updatedDate = updatedDateTime[0]; // '2024-11-29'

                  // Get the time part after the space
                  let updatedTime = updatedDateTime[1]; // '10:28:34'

                  // console.log("Updated Date:", updatedDate, updatedTime);

                  // Combine updatedDate and updatedTime with a space between them
                  const uploadedTime = updatedDate + " " + updatedTime;

                  // Assign uploadedTime to finalTime if confirmbtnTime was not set
                  if (!finalTime) {
                    finalTime = uploadedTime;
                  }
                } else {
                  // console.log("UpdatedDate is undefined or null");
                }

                // Log the final time
                // console.log("Final Time:", finalTime);

                // Get the current time
                const now = new Date();

                // Convert finalTime to Date object
                const finalDate = new Date(finalTime);

                // Calculate the time difference in milliseconds
                const timeDifference = now - finalDate; // in milliseconds

                // Convert time difference to hours
                const hoursDifference = timeDifference / (1000 * 60 * 60); // milliseconds to hours

                // Set the time limit based on priority
                let timeLimit;
                switch (Priority) {
                  case 1:
                    timeLimit = 1; // 1 hours
                    break;
                  case 2:
                    timeLimit = 2; // 3 hours
                    break;
                  case 3:
                    timeLimit = 3;
                  case 4:
                    timeLimit = 4; // 4 hours
                    break;
                  case 5:
                    timeLimit = 5; // 8 hours
                    break;
                  default:
                    timeLimit = 4; // 10 hours (for priority 5, as an example)
                }

                // Calculate the percentage of time used

                let exp_device =
                  patient.exp_device_use_days === 24
                    ? 1
                    : patient.exp_device_use_days === 48
                    ? 2
                    : patient.exp_device_use_days === 72
                    ? 3
                    : patient.exp_device_use_days;

                let timePercentage =
                  // (hoursDifference / (timeLimit * exp_device)) * 100;
                  (hoursDifference / (timeLimit * exp_device)) * 100; // Calculate the percentage of time used
                // *
                // patient.exp_device_use_days
                if (timePercentage > 100) {
                  timePercentage = 100; // Limit to 100% if the time exceeds the limit
                }
                // Calculate the completion rate (percentage per hour)
                // Calculate the completion rate (percentage per hour)
                const completionRate = timePercentage / hoursDifference; // percentage per hour

                // Predict the total time to complete 100% (in hours)
                const totalCompletionTime = 100 / completionRate; // in hours

                // Calculate the remaining time to complete (in hours)
                const remainingTimeInHours =
                  totalCompletionTime - hoursDifference;

                // Convert the remaining time to minutes
                const remainingTimeInMinutes = remainingTimeInHours * 60;

                // Convert minutes into hours and minutes
                const hours = Math.floor(remainingTimeInMinutes / 60); // Extract whole hours
                const minutes = Math.round(remainingTimeInMinutes % 60); // Get the remaining minutes

                // Log the predicted remaining time
                // console.log(
                //   `Predicted Remaining Time: ${hours} hours and ${minutes} minutes`
                // );

                // console.log("name", patient.name);
                // console.log("percetage", timePercentage);
                // console.log("timediff", timeDifference);
                // console.log("time limit", timeLimit);

                // Log the result
                // console.log(`Time used: ${hoursDifference.toFixed(2)} hours`);
                // console.log(`Time limit for Priority ${Priority}: ${timeLimit} hours`);
                // console.log(`Percentage of time used: ${timePercentage.toFixed(2)}%`);
                const percentage = timePercentage.toFixed(2);
                const devicemac =
                  patient && patient.deviceInfo && patient.deviceInfo.mac_id;
                // console.log("patient", devicemac);
                const Distributor_name =
                  patient &&
                  patient.deviceInfo &&
                  patient.deviceInfo.customer_details;
                const devicepriority =
                  patient && patient.deviceInfo && patient.deviceInfo.priority;

                const totalEcgValues = patient.ecgValues.length;
                const verifiedEcgValues = patient.ecgValues.filter(
                  (ecgValue) => ecgValue.verifyStatus === 1
                );
                const verifiedPercentage = `${verifiedEcgValues.length} /${totalEcgValues} `;

                // Numeric percentage for the progress bar (0-100)
                const verifiedPct = totalEcgValues > 0
                  ? Math.round((verifiedEcgValues.length / totalEcgValues) * 100)
                  : 0;

                const createdData = patient.created_at.split("T");

                let url = " ";
                let anl_btn_txt = "teststart";
                let anl_btn_class = "btn-danger";
                let gen_btn_txt = "Not Generated";
                let gen_btn_class = "btn-danger";
                let report_link = "#";
                let report_link_target = "";

                if (patient.LastDatasetId !== undefined) {
                  url =
                    patient.backup_status === 0 ||
                    patient.backup_status === undefined
                      ? `/verifier-unanalysed/${patient._id}/${patient.LastDatasetId}`
                      : " ";
                }

                if (patient.report_status >= 1) {
                  anl_btn_txt = "Analyzing...";
                  anl_btn_class = "btn-success";
                }

                if (patient.report_status >= 2) {
                  anl_btn_txt = "test";
                  anl_btn_class = "btn-success";
                  url =
                    patient.backup_status === 0 ||
                    patient.backup_status === undefined
                      ? `/verifier-chart/${patient._id}/${patient.LastDatasetId}`
                      : " ";
                      // console.log("url", url);
                }

                if (patient.report_status >= 4) {
                  gen_btn_txt = "In Preparation";
                  gen_btn_class = "btn-yellow";
                }
                if (patient.report_status >= 5) {
                  gen_btn_txt = "Not Generated";
                  gen_btn_class = "btn-danger";
                  report_link_target = "_blank";
                }

                anl_btn_txt =
                  patient.backup_status === 0 ||
                  patient.backup_status === undefined
                    ? "TEST3"
                    : patient.backup_status === 1
                    ? "Retrieve"
                    : "Retrieving";

                const updateddate = patient.ConfirmupdatedDate
                  ? patient.ConfirmupdatedDate.replace("T", " ").split(
                      ".000Z"
                    )[0]
                  : patient.updatedDate;
                console.log("patients!!!!!", patient);
                data.rows.push({
                  slno: i + 1,
                  patientId: patient.device_id,
                  added_date: createdData[0],

                  name: capitalizeFirstLetter(patient.name), // Default value
                  distributor: Distributor_name, // Default value // Ensure `distributor` is populated
                  doctor_name: patient.doctorName, // Default value
                  priority: devicepriority || "N/A",

                  // Ensure `doctor_name` is populated
                  action: (
                    <React.Fragment>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: "6px",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        {/* Analyze status moved to MONITORING column */}
                        {/*
                          One-click "Confirm & List": flips Confirmation from
                          Hold → Yes and refetches. Use this when the customer
                          has confirmed the device and the patient is ready to
                          move back to the main patient list. The edit-modal
                          toggle (Yes/No/Hold) still works for the No path or
                          for re-holding.
                        */}
                        <button
                          type="button"
                          title="Customer confirmed → move back to Patient List"
                          onClick={() =>
                            this.confirmPatient(patient._id, patient.name)
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            minWidth: "32px",
                            height: "32px",
                            padding: "0 10px",
                            margin: 0,
                            fontSize: "12px",
                            fontWeight: 700,
                            borderRadius: "6px",
                            background: "#27ae60",
                            color: "#fff",
                            border: "none",
                            cursor: "pointer",
                            boxShadow: "0 2px 4px rgba(39,174,96,0.35)",
                          }}
                        >
                          ✓ Confirm
                        </button>
                        {this.state.verifiertype === "8" && (
                          <button
                            type="button"
                            id={patient._id}
                            dataid2={devicemac}
                            dataid3={devicepriority}
                            title="Edit"
                            style={{
                              width: "32px",
                              height: "32px",
                              padding: 0,
                              margin: 0,
                              fontSize: "16px",
                              borderRadius: "6px",
                              background: "#f39c12",
                              color: "#fff",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={this.getInfo}
                            data-toggle="modal"
                            data-target="#editInfoModal"
                          >
                            ✏️
                          </button>
                        )}
                        <button
                          key={patient.id}
                          id={patient._id}
                          hourcomplete={`${hours} hours and ${minutes} minutes`}
                          type="button"
                          title="Progress"
                          style={{
                            minWidth: "62px",
                            height: "32px",
                            padding: "0 8px",
                            margin: 0,
                            fontSize: "12px",
                            fontWeight: 600,
                            borderRadius: "6px",
                            background: "#3498db",
                            color: "#fff",
                            border: "none",
                            cursor: "pointer",
                          }}
                          data-toggle="modal"
                          onClick={this.getverifiedprogress}
                          data-target="#progressinfomodal"
                        >
                          {verifiedPercentage}
                        </button>
                        {/* {this.state.verifiertype === "8" && (
                          <select
                            style={{
                              color: "black",
                              width: "110px",
                              height: "36px",
                              float: "left",
                              backgroundColor: "gray",
                              border: "none",
                            }}
                          >
                            {this.state.allverifiers.filter((verifier) =>
                              verifier.patients.includes(patient._id)
                            ).length === 0 && (
                              <option
                                style={{ color: "gray" }}
                                disabled
                                selected
                              >
                                Not Assigned
                              </option>
                            )}
                            {this.state.allverifiers
                              .filter((verifier) =>
                                verifier.patients.includes(patient._id)
                              )
                              .map((verifier) => (
                                <option
                                  style={{ color: "black" }}
                                  key={verifier._id}
                                  value={verifier._id}
                                >
                                  {verifier.name}
                                </option>
                              ))}
                          </select>
                        )} */}

                        <button
                          type="button"
                          id={patient._id}
                          title="Comments"
                          style={{
                            width: "32px",
                            height: "32px",
                            padding: 0,
                            margin: 0,
                            fontSize: "16px",
                            borderRadius: "6px",
                            background: "#e67e22",
                            color: "#fff",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={this.getInfo}
                          data-toggle="modal"
                          data-target="#commentinfomodal"
                        >
                          💬
                        </button>

                        {this.state.verifiertype === "8" &&
                        !patient.ConfirmupdatedDate ? (
                          <button
                            type="button"
                            id={patient._id}
                            title="Confirm Time"
                            style={{
                              width: "32px",
                              height: "32px",
                              padding: 0,
                              margin: 0,
                              fontSize: "16px",
                              borderRadius: "6px",
                              background: "#27ae60",
                              color: "#fff",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={this.getConfirmTime}
                          >
                            ✅
                          </button>
                        ) : null}
                      </div>

                      {/* Held by — last actor to set this patient's
                          Confirmation. Shows staff name OR 📱 Customer
                          (WhatsApp) so the on-call team can see at a glance
                          who put the patient on Hold and through which path. */}
                      {(patient.ConfirmedBy || patient.ConfirmationSource) && (
                        <div
                          style={{
                            marginTop: "6px",
                            fontSize: "10px",
                            color: "#aaa",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "3px",
                            justifyContent: "center",
                            width: "100%",
                          }}
                          title={
                            patient.ConfirmupdatedDate
                              ? `Last set on ${patient.ConfirmupdatedDate
                                  .replace("T", " ")
                                  .split(".")[0]}`
                              : ""
                          }
                        >
                          {patient.ConfirmationSource === "whatsapp"
                            ? "📱 "
                            : "👤 "}
                          {patient.ConfirmedBy ||
                            (patient.ConfirmationSource === "whatsapp"
                              ? "Customer (WhatsApp)"
                              : "Staff")}
                        </div>
                      )}
                    </React.Fragment>
                  ),

                  report: (
                    <div
                      style={
                        this.state.verifiertype !== "8"
                          ? { display: "none", width: "100%" }
                          : { width: "100%" }
                      }
                    >
                      {/* Progress bar to show the percentage of completion */}
                      <div style={{ margin: "6px 0" }}>
                        <label htmlFor="progressBar" style={{ fontSize: "11px", marginBottom: 4 }}>
                          TAT: {hours} Hrs:{minutes} min
                        </label>
                        <div
                          style={{
                            height: "18px",
                            width: "100%",
                            backgroundColor: "#e0e0df",
                            borderRadius: "5px",
                            overflow: "hidden",
                            marginTop: "3px",
                            position: "relative",
                          }}
                        >
                          {/* Progress bar filled section */}
                          <div
                            style={{
                              height: "100%",
                              width: `${timePercentage}%`, // Adjust based on percentage value
                              backgroundColor:
                                timePercentage >= 80
                                  ? "#8f0303"
                                  : timePercentage >= 50
                                  ? "orange"
                                  : "#2ecd99", // Red for 80-100%, Orange for 50-79%, Green otherwise
                              transition: "width 0.5s ease",
                              position: "absolute",
                              top: 0,
                              left: 0,
                            }}
                          ></div>

                          {/* Centered percentage text */}
                          <div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              height: "100%",
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "bold",
                              color: "#120d0d", // Sets the text color to black
                            }}
                          >
                            {timePercentage.toFixed(2)}%
                          </div>
                        </div>
                      </div>

                      <React.Fragment>
                        <a
                          id={patient._id}
                          style={
                            gen_btn_class === "btn-yellow"
                              ? { backgroundColor: "#2ecd99" }
                              : {}
                          }
                          onClick={() =>
                            this.generateReport(
                              patient.report_status,
                              patient._id
                            )
                          }
                        >
                          <button
                            type="button"
                            className={`btn ${gen_btn_class}`}
                            style={
                              gen_btn_class === "btn-yellow"
                                ? { backgroundColor: "#2ecd99" }
                                : {}
                            }
                          >
                            {gen_btn_txt}
                          </button>
                        </a>
                        <input
                          type="hidden"
                          className="patientLink"
                          value={url}
                        />
                      </React.Fragment>
                    </div>
                  ),

                  monitoring_duration: (
                    <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "4px", alignItems: "center" }}>
                      {/* Duration + upload time */}
                      <div style={{ fontSize: "11px", lineHeight: 1.35, textAlign: "center" }}>
                        <div style={{ fontWeight: 600 }}>{patient.exp_device_use_days} DAYS</div>
                        <div style={{ opacity: 0.75 }}>({updateddate})</div>
                      </div>

                      {/* Progress bar — narrower, same color thresholds as patient-list */}
                      <div
                        style={{
                          height: "14px",
                          width: "70%",
                          backgroundColor: "#e0e0e0",
                          borderRadius: "4px",
                          overflow: "hidden",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            width: `${verifiedPct}%`,
                            backgroundColor:
                              verifiedPct >= 80
                                ? "#ff6b6b"
                                : verifiedPct >= 50
                                ? "#ffa500"
                                : "#4caf50",
                            transition: "width 0.3s ease",
                            position: "absolute",
                            top: 0,
                            left: 0,
                          }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            height: "100%",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: 700,
                            fontSize: "10px",
                            color: "#1a1a1a",
                          }}
                        >
                          {verifiedPct}%
                        </div>
                      </div>
                    </div>
                  ),
                  TimePercentage: (
                    <div
                      style={{
                        color: "transparent",
                        display: "flex",
                        position: "absolute",
                      }}
                    >
                      {percentage}
                    </div>
                  ),
                  hourstocompleted: (
                    <div
                      style={{
                        color: "transparent",
                        display: "flex",
                        position: "absolute",
                      }}
                    >
                      {`${hours} hours and ${minutes} minutes`}
                    </div>
                  ),
                });
              });

              this.setState({ data: data });
              this.setState({ columns: data.columns });
              this.setState(
                {
                  rows: data.rows.sort((a, b) => {
                    // Parse priorities and default to 4 if not provided
                    const priorityA = parseInt(a.priority || 4);
                    const priorityB = parseInt(b.priority || 4);

                    // Parse TimePercentage values and default to 0 if not provided
                    const timePercentageA = parseFloat(
                      a.TimePercentage.props.children || 0
                    );
                    const timePercentageB = parseFloat(
                      b.TimePercentage.props.children || 0
                    );

                    // Sort by priority first (ascending)
                    if (priorityA !== priorityB) {
                      return priorityA - priorityB; // Lower priority values come first
                    }

                    // If priority is the same, sort by TimePercentage (descending)
                    return timePercentageB - timePercentageA; // Higher percentages come first
                  }),
                },
                () => {
                  this.applyRowStyles(); // Apply styles to rows

                  // Bind click events for table rows after setting state
                  const table = document.getElementById("table");
                  if (table) {
                    table.addEventListener("click", this.handleRowClick);
                  }
                }
              );

              // this.setState({ data }, () => {
              //   this.applyRowStyles();

              //   // Bind click events for table rows
              //   const table = document.getElementById("table");
              //   table.addEventListener("click", (event) => {
              //     const target = event.target;
              //     if (
              //       target.closest(
              //         "td:nth-child(2), td:nth-child(3), td:nth-child(4)"
              //       )
              //     ) {
              //       const url = target
              //         .closest("tr")
              //         .querySelector(".patientLink").value;
              //       if (url !== " ") {
              //         window.location.href = url;
              //         // console.log("url:", url);
              //       }
              //     }
              //   });
              // });
            }
          );
        })
      )
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  };
  handleRowClick(event) {
    const target = event.target;

    // Check if the click happened on the specific columns (2, 3, or 4)
    if (target.closest("td:nth-child(2), td:nth-child(3), td:nth-child(4)")) {
      const row = target.closest("tr");
      const urlElement = row.querySelector(".patientLink");
      const url = urlElement ? urlElement.value : ""; // Avoid optional chaining

      // Check if a URL exists and navigate to it
      if (url && url.trim() !== "") {
        window.location.href = url;
      }
    }
  }

  applyRowStyles() {
    const { rows } = this.state;

    if (rows) {
      // Directly modify styles in JSX instead of using jQuery
      const updatedRows = rows.map((row) => {
        const percentage = parseFloat(row.TimePercentage.props.children); // Get the percentage as a float

        let backgroundColor = "#8f8b8b"; // Default color
        if (percentage >= 50 && percentage <= 70) {
          backgroundColor = "#008080"; // Light green for percentage 50-60
        } else if (percentage >= 71 && percentage <= 90) {
          backgroundColor = "#2ecd99"; // Light yellow for percentage 71-90
        } else if (percentage >= 91 && percentage <= 100) {
          backgroundColor = "#e0544a"; // Dark yellow for percentage 91-100
        }

        // Return the updated row with a background color
        return { ...row, backgroundColor };
      });

      // Update state with the new rows including the background color
      this.setState({ rows: updatedRows });
    }
  }

  submitComment = async (e) => {
    const userid = e.currentTarget.id;
    const newText = (this.state.newComment || "").trim();
    if (!newText) return; // nothing to submit
    const verifiername = localStorage.getItem("verifiername") || "Unknown";
    const timestamp = new Date().toLocaleString("en-IN", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true,
    });
    const newEntry = `${newText} — ${verifiername} [${timestamp}]`;
    // Append new entry to existing history
    const existing = (this.state.comments || "").trim();
    const comments = existing ? `${existing}\n${newEntry}` : newEntry;

    try {
      await axios.post(`${apiUrl}api/patients/addComment/${userid}`, { comments });
      $(".closePopup").click();
      this.setState({ newComment: "", comments: "" });
      this.fetchData();
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };
  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };
  filterRows = () => {
    const { rows, searchQuery } = this.state;

    if (!searchQuery) {
      return rows; // If no search query, return all rows
    }

    return rows.filter((row) => {
      // You can modify this to check specific fields for a match
      return Object.values(row).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      );
    });
  };

  // Quick "Confirm & List" action for a single Hold patient.
  // Flips Patient.Confirmation from "Hold" → "Yes" via the same
  // /updateConfirmation endpoint the edit modal already uses, so the row
  // disappears from this page and reappears in /patient-list on next fetch.
  // No other state or page is touched.
  confirmPatient(patientId, patientName) {
    if (!patientId) return;
    const label = patientName ? `"${patientName}"` : "this patient";
    const ok = window.confirm(
      `Move ${label} back to Patient List?\n\n` +
        `This sets Confirmation to "Yes" — the patient will leave Patient-Hold ` +
        `and become visible in the main patient list immediately.`
    );
    if (!ok) return;

    axios
      .post(`${apiUrl}api/patients/updateConfirmation`, {
        userid: patientId,
        Confirmation: "Yes",
        // Source: this came from the explicit one-click ✓ Confirm action,
        // i.e. a staff member moving the patient back to the active list.
        // Distinct from the WhatsApp / Python (last_trigger.py) path that
        // tags writes as "whatsapp".
        ConfirmationSource: "staff",
        ConfirmedBy:
          localStorage.getItem("verifiername") || "Unknown staff",
        ConfirmedById: localStorage.getItem("verifierid") || null,
      })
      .then(() => {
        // Refresh both this page's list (so the row disappears) and any
        // local state that mirrors Confirmation. fetchData already pulls
        // Hold-only patients, so the row drops naturally.
        this.fetchData();
      })
      .catch((err) => {
        console.error("confirmPatient — updateConfirmation failed:", err);
        window.alert(
          "Could not move the patient. Please try again, or use the edit modal."
        );
      });
  }

  // Method to apply styles to rows based on priority

  handleDoctorChange = (selectedOption) => {
    this.setState({ selectedDoctor: selectedOption });
    // console.log("Selected doctor:", selectedOption);
    // Perform any action needed with the selected doctor
  };

  async generateReport(reportstatus, userid) {
    //  const userid=e.currentTarget.id

    // console.log("generate event id:", userid);
    this.setState({ generatereportuserid: userid });
    if (reportstatus == "2" || reportstatus == "6") {
      const res = await axios.get(
        apiUrl + "api/common/patinentmenutreeNew?userid=" + userid
      );

      this.setState({ treemenu: res.data });

      this.setState({ isModalReportOpen: true });
    }
    if (reportstatus == "4") {
      const res = await axios.get(
        apiUrl + "api/common/patinentmenutreeNew?userid=" + userid
      );

      this.setState({ treemenu: res.data });
      this.setState({ isModalReportOpen: true });
    } else {
      this.setState({ isModalReportOpen: false });
    }
  }

  handleVerifierChange = (selectedOptions) => {
    this.setState({
      selectedVerifiers: selectedOptions || [], // Update selected verifiers or set empty array if none
    });
    // console.log("selected options", selectedOptions);
    // console.log(
    //   "selected verifier state",
    //   this.state.selectedVerifiers,
    //   this.state.selectedVerifierIds
    // );
  };

  handleModalComplete(id) {
    // console.log("id:", id);
    this.state.userid = id;
    this.setState({ isModalCompleteOpen: true });
  }

  onSubmit = (e) => {
    e.preventDefault();

    const settings = {
      userid: this.state.userid,
      nor_minhr: this.state.nor_minhr,
      nor_maxhr: this.state.nor_maxhr,
      qtcformula: this.state.qtcformula,
      qtcvalue_min: this.state.qtcvalue_min,
      qtcvaluemax: this.state.qtcvaluemax,
      qrswidth_min: this.state.qrswidth_min,
      qrswidth_max: this.state.qrswidth_max,
      qrsamp_min: this.state.qrsamp_min,
      qrsamp_max: this.state.qrsamp_max,
      stelevation: this.state.stelevation,
      pwidth_min: this.state.pwidth_min,
      pwidth_max: this.state.pwidth_max,
      pamp_min: this.state.pamp_min,
      pamp_max: this.state.pamp_max,
      stdepression: this.state.stdepression,
      twidth_min: this.state.twidth_min,
      twidth_max: this.state.twidth_max,
      tamp_min: this.state.tamp_min,
      tamp_max: this.state.tamp_max,
      printerval_min: this.state.printerval_min,
      printerval_max: this.state.printerval_max,
      tachyhr_lower: this.state.tachyhr_lower,
      tachyhr_upper: this.state.tachyhr_upper,
      bradyhr_lower: this.state.bradyhr_lower,
      bradyhr_upper: this.state.bradyhr_upper,
      pauselength: this.state.pauselength,
      graph_gen: this.state.graph_gen,
    };

    // console.log(settings);
    axios
      .post(apiUrl + "api/patients/updateSettings", settings)
      .then((res) => {
        $("#closePopup").click();
        // console.log("onclick");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onSubmitInfo = (e) => {
    e.preventDefault();

    //   this.state.selectedVerifiers.forEach(verifier => {
    //     console.log("Verifier ID:", verifier.value);
    // });

    const info = {
      name: this.state.patient_name,
      patientid: this.state.userid,
      userid: this.state.userid,
      dob: this.state.dob,
      weight: this.state.weight,
      height: this.state.height,
      hospital: this.state.hospital,
      phone: this.state.phone,
      email: this.state.email_id,
      doctorid: this.state.selectedDoctor.value,
      ipop: this.state.ipop,
      fileType: this.state.filetype || "easy",
      verifierid: this.state.selectedVerifiers.map(
        (verifier) => verifier.value
      ),
      priority: this.state.priority,

      reportstatus: this.state.reportstatus,
      // smoking: this.state.smoking,
      // diabetes: this.state.diabetes,
      af: this.state.af,
      // hyper_tension: this.state.hyper_tension,
      // hyper_lipidemia: this.state.hyper_lipidemia,
      hyper_lipidemia: this.state.pacemaker,
      indication: this.state.indication,
      cardiac_surgery: this.state.cardiac_surgery,
      thyroid: this.state.thyroid_function,
      exp_device_use_days: this.state.duration,
      issueReported: this.state.issueReport,
      supportLevel: this.state.supportLevel,
      supportPerson: this.state.supportPerson,
      supportcomment: this.state.supportedMatter,
      prioritizeData: this.state.prioritizeData, // <-- Add this line
      clinicalCondition: this.state.clinicalCondition, // <-- Add this line
    };
    // console.log("info:", this.state.clinicalCondition);

    const deviceinfoupdate = {
      mac_id: this.state.macid,
      priority: this.state.priority,
    };

    axios
      .post(apiUrl + "api/patients/updateInfo_new_info_test", info)
      .then((res) => {
        // Handle the response of the first request
        // console.log("Patient info updated:", res.data);
        if (this.state.macid != null) {
          // If macid is either undefined or null
          return axios.put(
            `${apiUrl}api/patients/updateDevicePriority`,
            deviceinfoupdate
          );
        }
      })

      .then((res) => {
        // Handle the response of the second request
        // console.log("Device priority updated:", res.data);
        $(".closePopup").click();
        this.fetchData(); // Fetch updated data
      })
      .catch((err) => {
        // Handle any errors from either request
        console.error("Error occurred:", err);
      });
  };

  onChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    // console.log("onChange");
    // console.log(e.target.name);
    // console.log(e.target.value);
    // console.log(e.target)
    // this.setState({reportstatus:e.target.value})
    // console.log(e.target.value)

    this.setState({ [e.target.name]: e.target.value });
  };
  handleTypeChange = (e) => {
    // console.log("e.target.value", e.target.value);
    this.setState({ filetype: e.target.value });
  };
  handleDateChange = (inputDate) => {
    // Check if the input date is a valid ISO string
    if (moment(inputDate, moment.ISO_8601, true).isValid()) {
      // Convert the input string into a Date object
      const date = new Date(inputDate);

      // Format the date as desired (ISO format with time zone offset)
      const formattedDate = format(date, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");

      // console.log("Formatted Date:", formattedDate);
      // Outputs: 2024-11-06T00:00:00.000+05:30
      this.setState({ dob: formattedDate });
    } else {
      console.error("Invalid date format:", inputDate);
    }
  };
  onIpOpChange = (e) => {
    console.log("ipop", e.target.value);
    this.setState({ ipop: e.target.value });
  };
  onDurationChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    this.setState({ duration: e.target.value });
    console.log(this.state.duration);
  };
  onPriorityChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];

    // console.log(e.target.value)
    this.setState({ priority: e.target.value });
  };
  onReportStatuschange = (e) => {
    // console.log("report stats change",e.target.value)
    this.setState({ reportstatus: e.target.value });
  };
  onGenderChange = (e) => {
    this.setState({ gender: e.target.value });
  };

  preventDefault(e) {
    e.preventDefault();
  }
  HandleVerifiedSpeed(e) {
    // console.log(e.target.value);
  }
  getInfo(e) {
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      loadingEditModal: true, // Set loading to true when starting
      supportPerson: "",
      supportLevel: "",
      supportedMatter: "",
    });
    this.setState({ isModalCompleteOpen: false });
    var userid = e.currentTarget.id;
    const dataid2 = e.target.getAttribute("dataid2");
    const dataid3 = e.target.getAttribute("dataid3");
    this.setState({ userid: userid });
    axios
      .get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${userid}`)
      .then((res) => {
        const data = res.data[0];
        if (
          data.gender === "MALE" ||
          data.gender === "male" ||
          data.gender === "Male" ||
          data.gender === "M" ||
          data.gender === "m"
        ) {
          this.setState({ gender: "M" });
        }

        if (
          data.gender === "FEMALE" ||
          data.gender === "female" ||
          data.gender === "Female" ||
          data.gender === "F" ||
          data.gender === "f"
        ) {
          this.setState({ gender: "F" });
        }
        if (data.gender === "Select Gender") {
          this.setState({ gender: "M" });
        }

        if (Array.isArray(this.state.patients)) {
          this.state.patients.forEach((patient) => {
            if (patient._id === userid) {
              this.setState({ reportstatus: patient.report_status });
              // console.log("report status", patient.report_status);
            }
          });
        }
        data.customer_details.forEach((customer) => {
          if (customer.customer_details) {
            // console.log('Nested Customer Details:', customer);
            this.setState({ customer_details: customer.customer_details });
          }
        });
        // console.log(this.state.patients);
        console.log("additional data!!!!!!!!!!!!!!!", data);
        // Update state with patient info
        this.setState({
          af: data.af ? "yes" : "no",
          duration: data.exp_device_use_days,
          cardiac_surgery: data.cardiac_surgery ? "yes" : "no",
          thyroid_function: data.thyroid,
          diabetes: data.diabetes,
          indication: data.indication,
          height: data.height,
          weight: data.weight,
          hospital: data.hospital,
          phone: data.phone,
          patient_name: data.name,
          email_id: data.email,
          selectedDoctor: { value: data.doctor_id, label: data.doctor_name },
          macid: dataid2,
          priority: dataid3,
          dob: data.dob,
          duration: data.exp_device_use_days,
          filetype: data.fileType,
          pacemaker: data.hyper_lipidemia,
          issueReport: data.issueReported,
          Confirmation: data.Confirmation,
          supportedMatter: data.supportcomment,
          supportPerson: data.supportPerson,
          supportLevel: data.supportLevel,
          prioritizeData: data.priorityStatus || "No",
          clinicalCondition: data.clinicalCondition || "", // <-- Add this line
        });
        // console.log("clinical condition:", data.clinicalCondition);
        // Handle DOB formatting
        let formattedDob = data.dob;
        if (formattedDob) {
          // Convert ISO string or YYYY-MM-DD to MM/DD/YYYY for display
          const dateObj = new Date(formattedDob);
          if (!isNaN(dateObj.getTime())) {
            const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
            const dd = String(dateObj.getDate()).padStart(2, "0");
            const yyyy = dateObj.getFullYear();
            formattedDob = `${mm}/${dd}/${yyyy}`;
          }
        }
        this.setState({ dob: formattedDob });
        // console.log("Formatted DOB:", this.state.dob);

        // Second API call for verifiers
        return axios.get(`${apiUrl}api/users/allverifiers`);
      })
      .then((res) => {
        const verifiers = res.data;
        const formattedVerifiers = verifiers.map((verifier) => ({
          value: verifier._id,
          label: verifier.name,
          patients: verifier.patients, // Assuming patients is an array of user IDs
        }));

        const filteredVerifiers = formattedVerifiers.filter((verifier) =>
          verifier.patients.includes(userid)
        );

        // console.log('Filtered verifiers with matching user:', this.state.priority);

        this.setState({ selectedVerifiers: filteredVerifiers });

        this.setState({ verifiers: formattedVerifiers });
        // console.log('formatted verifiers:',verifiers)
        // Third API call for patient search (ipop)
        this.state.patients.forEach((patient) => {
          if (patient._id === userid) {
            this.setState({ comments: patient.comments });
            // this.setState({ priority: patient.priority });
            this.setState({ ipop: patient.ip_op });
          }
        });

        // console.log("ipop", this.state.patients);

        // Fourth API call for verified percentage
        return axios.get(`${apiUrl}api/users/getVerifiedPercentage/${userid}`);
      })
      .then((res) => {
        const ecgValues = res.data.ecgValues; // Assuming `ecgValues` is an array
        const totalLength = ecgValues.length;
        let verifyCount = 0; // Initialize verify count

        ecgValues.forEach((value, index) => {
          if (value.verifyStatus === 1) {
            // console.log(`Link for ECG value at index ${index}:`, value.link); // Assuming there's a 'link' property
            verifyCount++; // Increment the verify count
          }
        });

        // console.log('Total verified ECG values:', verifyCount);
        // console.log('Total count:', totalLength);

        if (totalLength > 0) {
          // console.log('ECG data is available.');

          // Calculate and log the percentage of verified ECG values
          const percentageVerified = (verifyCount / totalLength) * 100;
          // console.log('Percentage of verified ECG values:', percentageVerified.toFixed(2) + '%');
          this.setState({ percentageVerified: percentageVerified.toFixed(2) });
          // console.log('verified percentage:',this.state.percentageVerified)
        } else {
          // console.log('No ECG data found.');
        }
        this.setState({ loadingEditModal: false }); // Data loaded, hide spinner
        axios.get(`${apiUrl}api/common/getSupportPerson`).then((res) => {
          if (res.data && Array.isArray(res.data)) {
            this.setState({ supportPersons: res.data });
            // console.log("support persons:!!!!!!!!!!!!!!!!!!!!!!", this.state.supportPersons);
          }
        });
      })

      .catch((error) => {
        console.error("Error fetching ECG data:", error);
        this.setState({ loadingEditModal: false }); // Hide spinner on error
      });
  }
  getverifiedprogress(e) {
    this.setState({ isModalCompleteOpen: false });
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      hourstocompleted: "",
      selectedVerifiersEfficency: [],
    });

    var userid = e.currentTarget.id;
    const dataid2 = e.target.getAttribute("dataid2");
    const dataid3 = e.target.getAttribute("dataid3");
    const hourstocompleted = e.target.getAttribute("hourcomplete");
    this.setState({ hourstocompleted: hourstocompleted });

    // console.log("current target", hourstocompleted);
    this.setState({ userid: userid });

    axios
      .get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${userid}`)
      .then((res) => {
        const data = res.data[0];

        if (Array.isArray(this.state.patients)) {
          this.state.patients.forEach((patient) => {
            if (patient._id === userid) {
              this.setState({ reportstatus: patient.report_status });
              // console.log("report status", patient.report_status);
            }
          });
        }
        data.customer_details.forEach((customer) => {
          if (customer.customer_details) {
            // console.log('Nested Customer Details:', customer);
            this.setState({ customer_details: customer.customer_details });
          }
        });
        // console.log(this.state.patients);

        // Update state with patient info
        this.setState({
          af: data.af ? "yes" : "no",
          duration: data.exp_device_use_days,
          cardiac_surgery: data.cardiac_surgery ? "yes" : "no",
          thyroid_function: data.thyroid,
          diabetes: data.diabetes,
          indication: data.indication,
          height: data.height,
          weight: data.weight,
          hospital: data.hospital,
          phone: data.phone,
          patient_name: data.name,
          email_id: data.email,
          selectedDoctor: { value: data.doctor_id, label: data.doctor_name },
          macid: dataid2,
          priority: dataid3,
          dob: data.dob,
          duration: data.exp_device_use_days,
          filetype: data.fileType,
        });

        // Handle DOB formatting
        const dob = new Date(Date.parse(data.dob));
        const formattedDob = `${
          dob.getMonth() + 1
        }/${dob.getDate()}/${dob.getFullYear()}`;
        this.setState({ dob: formattedDob });

        // Second API call for verifiers
        return axios.get(`${apiUrl}api/users/allverifiers_new`);
      })
      .then((res) => {
        const verifiers = res.data;
        const formattedVerifiers = verifiers.map((verifier) => ({
          value: verifier._id,
          label: verifier.name,
          patients: verifier.patients, // Assuming patients is an array of user IDs
        }));

        const filteredVerifiers = formattedVerifiers.filter((verifier) =>
          verifier.patients.includes(userid)
        );
        // console.log("filtered verifier!!!!!", filteredVerifiers);

        // console.log('Filtered verifiers with matching user:', this.state.priority);

        this.setState({ selectedVerifiers: filteredVerifiers });

        this.setState({ verifiers: formattedVerifiers });
        // console.log('formatted verifiers:',verifiers)
        // Third API call for patient search (ipop)
        this.state.patients.forEach((patient) => {
          if (patient._id === userid) {
            this.setState({ comments: patient.comments });
            // this.setState({ priority: patient.priority });
            this.setState({ ipop: patient.ip_op });
          }
        });

        // console.log("ipop", this.state.patients);

        // Fourth API call for verified percentage
        return axios.get(`${apiUrl}api/users/getVerifiedPercentage/${userid}`);
      })
      .then((res) => {
        const ecgValues = res.data.ecgValues; // Assuming `ecgValues` is an array
        const selectedVerifiers = this.state.selectedVerifiers;
        const fileType = this.state.filetype || "easy"; // 'easy', 'medium', 'hard'

        const allowedTimePerECGInMinutes =
          fileType === "easy" ? 4 : fileType === "medium" ? 6 : 9;

        const verifierEfficiencyResults = [];

        if (selectedVerifiers && selectedVerifiers.length > 0) {
          selectedVerifiers.forEach((verifier) => {
            const filteredECGValues = ecgValues
              .filter((ecg) => ecg.verifierId === verifier.value)
              .sort((a, b) => new Date(a.verifyTime) - new Date(b.verifyTime));

            if (filteredECGValues.length > 0) {
              // Here you can extract any data you need from `filteredECGValues` and pass it as a parameter
              // Assuming we are passing the `filteredECGValues` directly or extracting an ID or relevant data for `databaseid`
              const databaseId = filteredECGValues
                .map((ecg) => ecg.ecgvalue_id)
                .join(","); // Assuming `id` is the relevant field

              axios
                .post(
                  `${apiUrl}api/common/getTotalStripCount?userid=${userid}&databaseid=${databaseId}`
                )
                .then((apiResponse) => {
                  const apiData = apiResponse.data;

                  const totalMinutes = apiData; // Example input

                  const hours = Math.floor(totalMinutes / 60); // Get the number of hours
                  const minutes = totalMinutes % 60; // Get the remaining minutes

                  const formattedTime = `${hours}Hrs:${minutes
                    .toString()
                    .padStart(2, "0")}Mins`; // Format as hrs:mins
                  // console.log("Formatted time (hours:min):", formattedTime);

                  const startTime = new Date(filteredECGValues[0].verifyTime);
                  const endTime = new Date(
                    filteredECGValues[filteredECGValues.length - 1].verifyTime
                  );

                  let totalEfficientCount = 0;
                  let totalComparisons = 0;
                  let totalTimeSpentInMinutes = 0;

                  filteredECGValues.forEach((ecg, index) => {
                    if (index > 0) {
                      const prevVerifyTime = new Date(
                        filteredECGValues[index - 1].verifyTime
                      );
                      const currentVerifyTime = new Date(ecg.verifyTime);
                      const timeDifferenceInMinutes =
                        (currentVerifyTime - prevVerifyTime) / (1000 * 60);

                      totalTimeSpentInMinutes += timeDifferenceInMinutes;

                      if (
                        timeDifferenceInMinutes <= allowedTimePerECGInMinutes
                      ) {
                        totalEfficientCount++;
                      }

                      totalComparisons++;
                    }
                  });

                  const efficiency =
                    totalComparisons > 0
                      ? (totalEfficientCount / totalComparisons) * 100
                      : 0;
                  const averageTimePerECG =
                    totalComparisons > 0
                      ? totalTimeSpentInMinutes / totalComparisons
                      : 0;
                  const remainingECGCount =
                    ecgValues.length - filteredECGValues.length;
                  const estimatedRemainingTime =
                    averageTimePerECG * remainingECGCount;

                  verifierEfficiencyResults.push({
                    label: verifier.value,
                    value: efficiency.toFixed(2),
                    averageTimePerECG: averageTimePerECG.toFixed(2),
                    estimatedRemainingTime: estimatedRemainingTime.toFixed(2),
                    startTime: startTime.toISOString(),
                    endTime: endTime.toISOString(),
                    totalTimeSpentInMinutes: totalTimeSpentInMinutes || "N/A",
                    totalSpendHours: formattedTime || "N/A",
                    totalEfficientCount: totalEfficientCount || "N/A",
                  });

                  this.setState({
                    selectedVerifiersEfficency: verifierEfficiencyResults,
                  });
                })
                .catch((err) => {
                  console.error("Error fetching data from API", err);
                });
            } else {
              // console.log(
              //   `No ECG values found for Verifier ID: ${verifier.value}`
              // );
            }
          });
        } else {
          // console.log("No selected verifiers found.");
        }

        const totalLength = ecgValues.length;
        let verifyCount = 0;

        ecgValues.forEach((value) => {
          if (value.verifyStatus === 1) {
            verifyCount++;
          }
        });

        if (totalLength > 0) {
          const percentageVerified = (verifyCount / totalLength) * 100;
          this.setState({ percentageVerified: percentageVerified.toFixed(2) });
        }
      })

      .catch((error) => {
        console.error("Error fetching ECG data:", error);
      });
  }
  getConfirmTime(e) {
    // console.log(e.currentTarget.id);
    const userid = e.currentTarget.id;
    const now = new Date();
    const updatedDate = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
      now.getHours()
    ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
      now.getSeconds()
    ).padStart(2, "0")}`;

    // console.log("Clicked date and time:", updatedDate);

    // Make the API call
    axios
      .post(`${apiUrl}api/patients/updateUpdateDate`, {
        userid,
        updatedDate,
      })
      .then((response) => {
        // console.log(response);

        // Set showButton to false to hide the button after successful update
        this.setState({ showButton: false }, () => {
          // console.log("Button hidden:", this.state.showButton); // Ensure the state is updated
        });
        this.setState((prevState) => ({
          refreshKey: prevState.refreshKey + 1,
        }));
        this.fetchData();
      })
      .catch((error) => {
        // console.error("Error updating date:", error);
      });
  }

  selectItem(e) {
    var userid = e.currentTarget.id;
    this.setState({ userid: userid });
    this.setState({
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
    });
    axios
      .get(apiUrl + "api/patients/settings?userid=" + userid)
      .then((res) => {
        var data = res.data;
        this.setState(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  resetModalReport() {
    // console.log("resetmodal clicked!!!");
    this.setState({ isModalReportOpen: false });
    this.fetchData();
  }
  resetInfoModal() {
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      customer_details: "", // Reset customer details too
      reportstatus: "",
      dob: "",
      height: "",
      weight: "",
      hospital: "",
      phone: "",
      patient_name: "",
      email_id: "",
      doctor_name: "",
      doctor_id: "",
      duration: "",
      selectedVerifiers: [],
      verifiers: [],
      comments: "",
      priority: "",
      ipop: "",
      percentageVerified: "",
      macid: "",
      filetype: "",
      hourstocompleted: "",
      loadingEditModal: false, // Reset loading state
    });
    // console.log(this.state.verifiers);
  }
  // Add these methods to your class:
  handleConfirmationClick = () => {
    this.setState({
      isConfirmationModalOpen: true,
      selectedConfirmation: this.state.Confirmation,
    });
  };

  handleConfirmationChange = (e) => {
    this.setState({ selectedConfirmation: e.target.value });
  };

  handleConfirmationSubmit = async () => {
    try {
      await axios.post(`${apiUrl}api/patients/updateConfirmation`, {
        userid: this.state.userid,
        Confirmation: this.state.selectedConfirmation,
      });
      toast.success(
        `Confirmation Updated to: ${this.state.selectedConfirmation}`
      );
      this.setState({
        Confirmation: this.state.selectedConfirmation,
        isConfirmationModalOpen: false,
      });
      this.fetchData();
    } catch (error) {
      console.error("Error updating confirmation:", error);
    }
  };

  handleConfirmationCancel = () => {
    this.setState({ isConfirmationModalOpen: false });
  };

  render() {
    if (localStorage.jwtToken == undefined) {
      window.location.href = "/";
    }
    const filteredRows = this.filterRows();
    const { errors, doctors, selectedDoctor, dob } = this.state;
    const options = doctors.map((doctor) => ({
      value: doctor._id,
      label: doctor.name,
    }));

    /* const { errors,doctors } = this.state;*/

    // Map filtered doctors to options
    // const doctorsList =
    //   filteredDoctors.length > 0
    //     ? filteredDoctors.map((item, i) => (
    //         <option
    //           key={i}
    //           value={item._id}
    //           selected={doctor_name === item.name}
    //         >
    //           {item.name}
    //         </option>
    //       ))
    //     : null;
    return (
      <div className="wrapper theme-6-active box-layout pimary-color-green">
        <TopNav profileLink={this.state.profileLink} />
        <Toaster position="top-right" reverseOrder={false} />

        <AddModalReport
          userid={this.state.generatereportuserid}
          onSelectModalReport={this.resetModalReport.bind(this)}
          isOpen={this.state.isModalReportOpen}
          treemenu={this.state.treemenu}
        />
        <AddModalComplete
          userid={this.state.userid}
          isOpen={this.state.isModalCompleteOpen}
        />
        <SideBar menus={this.state.menus} />

        <div className="right-sidebar-backdrop"></div>
        <div className="page-wrapper" style={{ marginTop: "6px", background: "#041415", minHeight: "100vh" }}>
          <div className="container-fluid" style={{ padding: "8px 4px" }}>
            <div id="myModalDHome" className="modal fade" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">
                      General Settings
                    </h4>
                  </div>
                  <form method="post" onSubmit={this.onSubmit}>
                    <div className="modal-body">
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Normal Heart Rate Min
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.nor_minhr,
                              })}
                              name="nor_minhr"
                              required=""
                              id="nor_minhr"
                              onChange={this.onChange}
                              value={this.state.nor_minhr}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Normal Heart Rate Max
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.nor_maxhr,
                              })}
                              name="nor_maxhr"
                              required=""
                              id="nor_maxhr"
                              onChange={this.onChange}
                              value={this.state.nor_maxhr}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Formula
                            </label>
                            <select
                              name="qtcformula"
                              className={classnames("form-control", {
                                errors: errors.qtcformula,
                              })}
                              value={this.state.qtcformula}
                              onChange={this.onChange}
                            >
                              <option value="Bazett">Bazett </option>
                              <option value="Fridericia">Fridericia</option>
                              <option value="Framingham">Framingham</option>
                              <option value="Hodges">Hodges</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Value Min
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qtcvalue_min,
                              })}
                              name="qtcvalue_min"
                              required=""
                              id="qtcvalue_min"
                              onChange={this.onChange}
                              value={this.state.qtcvalue_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Value Max
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qtcvaluemax,
                              })}
                              name="qtcvaluemax"
                              required=""
                              id="qtcvaluemax"
                              onChange={this.onChange}
                              value={this.state.qtcvaluemax}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Width Min(ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrswidth_min,
                              })}
                              name="qrswidth_min"
                              required=""
                              id="qrswidth_min"
                              onChange={this.onChange}
                              value={this.state.qrswidth_min}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Width Max (ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrswidth_max,
                              })}
                              name="qrswidth_max"
                              required=""
                              id="qrswidth_max"
                              onChange={this.onChange}
                              value={this.state.qrswidth_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrsamp_min,
                              })}
                              name="qrsamp_min"
                              required=""
                              id="qrsamp_min"
                              onChange={this.onChange}
                              value={this.state.qrsamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrsamp_max,
                              })}
                              name="qrsamp_max"
                              required=""
                              id="qrsamp_max"
                              onChange={this.onChange}
                              value={this.state.qrsamp_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              ST Elevation (mm)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.stelevation,
                              })}
                              name="stelevation"
                              required=""
                              id="stelevation"
                              onChange={this.onChange}
                              value={this.state.stelevation}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Width Min (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pwidth_min,
                              })}
                              name="pwidth_min"
                              required=""
                              id="pwidth_min"
                              onChange={this.onChange}
                              value={this.state.pwidth_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Width Max (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pwidth_max,
                              })}
                              name="pwidth_max"
                              required=""
                              id="pwidth_max"
                              onChange={this.onChange}
                              value={this.state.pwidth_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pamp_min,
                              })}
                              name="pamp_min"
                              required=""
                              id="pamp_min"
                              onChange={this.onChange}
                              value={this.state.pamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pamp_max,
                              })}
                              name="pamp_max"
                              required=""
                              id="pamp_max"
                              onChange={this.onChange}
                              value={this.state.pamp_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Width Min (ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.twidth_min,
                              })}
                              name="twidth_min"
                              required=""
                              id="twidth_min"
                              onChange={this.onChange}
                              value={this.state.twidth_min}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Width Max (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.twidth_max,
                              })}
                              name="twidth_max"
                              required=""
                              id="twidth_max"
                              onChange={this.onChange}
                              value={this.state.twidth_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tamp_min,
                              })}
                              name="tamp_min"
                              required=""
                              id="tamp_min"
                              onChange={this.onChange}
                              value={this.state.tamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tamp_max,
                              })}
                              name="tamp_max"
                              required=""
                              id="tamp_max"
                              onChange={this.onChange}
                              value={this.state.tamp_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              PR Interval Min{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.printerval_min,
                              })}
                              name="printerval_min"
                              required=""
                              id="printerval_min"
                              onChange={this.onChange}
                              value={this.state.printerval_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              PR Interval Max{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.printerval_max,
                              })}
                              name="printerval_max"
                              required=""
                              id="printerval_max"
                              onChange={this.onChange}
                              value={this.state.printerval_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Tachy Lower Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tachyhr_lower,
                              })}
                              name="tachyhr_lower"
                              required=""
                              id="tachyhr_lower"
                              onChange={this.onChange}
                              value={this.state.tachyhr_lower}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Tachy Upper Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tachyhr_upper,
                              })}
                              name="tachyhr_upper"
                              required=""
                              id="tachyhr_upper"
                              onChange={this.onChange}
                              value={this.state.tachyhr_upper}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Brady Lower Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.bradyhr_lower,
                              })}
                              name="bradyhr_lower"
                              required=""
                              id="bradyhr_lower"
                              onChange={this.onChange}
                              value={this.state.bradyhr_lower}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Brady Upper Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.bradyhr_upper,
                              })}
                              name="bradyhr_upper"
                              required=""
                              id="bradyhr_upper"
                              onChange={this.onChange}
                              value={this.state.bradyhr_upper}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              ST Depression (mm)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.stdepression,
                              })}
                              name="stdepression"
                              required=""
                              id="stdepression"
                              onChange={this.onChange}
                              value={this.state.stdepression}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Pause Length (s){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pauselength,
                              })}
                              name="pauselength"
                              required=""
                              id="pauselength"
                              onChange={this.onChange}
                              value={this.state.pauselength}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Graphs To Be Generated(no:){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.graph_gen,
                              })}
                              name="graph_gen"
                              required=""
                              id="graph_gen"
                              onChange={this.onChange}
                              value={this.state.graph_gen}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="submit"
                        className="btn btn-success"
                        style={{ color: "Black" }}
                      >
                        Submit
                      </button>
                      {
                        <button
                          id="closePopup"
                          type="button"
                          className="btn btn-default closePopup"
                          data-dismiss="modal"
                          style={{ color: "Black" }}
                        >
                          Close
                        </button>
                      }
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* ── Comments modal — mirrors patient-list ── */}
            <div id="commentinfomodal" className="modal fade" role="dialog" aria-hidden="true">
              <div className="modal-dialog" style={{ maxWidth: 860, margin: "20px auto", width: "94%" }}>
                <div className="modal-content" style={{ borderRadius: 10, overflow: "hidden", border: "none", boxShadow: "0 12px 40px rgba(0,0,0,0.4)" }}>

                  {/* Header */}
                  <div style={{ background: "#1e2d38", padding: "12px 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                      <div style={{ color: "#fff", fontWeight: 700, fontSize: "15px", display: "flex", alignItems: "center", gap: 6 }}>
                        💬 Comments{(this.state.comments || "").trim() ? ` (${(this.state.comments || "").trim().split("\n").filter(l => l.trim()).length})` : ""}
                      </div>
                      {this.state.patient_name && (
                        <div style={{ color: "#89c4e1", fontSize: "12px", marginTop: 2 }}>
                          {this.state.patient_name}
                          {this.state.userid && <span style={{ color: "#5a8fa8", marginLeft: 6, fontSize: "11px" }}>#{this.state.patientId || ""}</span>}
                        </div>
                      )}
                    </div>
                    <button type="button" data-dismiss="modal" className="closePopup"
                      style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", width: 28, height: 28, borderRadius: "50%", fontSize: "16px", lineHeight: 1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      ×
                    </button>
                  </div>

                  {/* Comment History */}
                  {(() => {
                    const raw = (this.state.comments || "").trim();
                    const lines = (raw ? raw.split("\n").filter((l) => l.trim()) : []).reverse(); // newest first
                    return (
                      <div style={{ background: "#f5f7fa", borderBottom: "1px solid #e2e8f0", maxHeight: "calc(100vh - 360px)", minHeight: 120, overflowY: "auto", padding: lines.length ? "12px 16px" : "0" }}>
                        {lines.length === 0 ? (
                          <div style={{ padding: "18px 16px", textAlign: "center", color: "#aaa", fontSize: "13px" }}>No comments yet</div>
                        ) : (
                          lines.map((line, idx) => {
                            const byMatch = line.match(/^(.*?)\s*[—–-]+\s*BY\s+(.+?)(?:\s*\[(.+?)\])?$/i)
                                         || line.match(/^(.*?)\s*—\s*(.+?)(?:\s*\[(.+?)\])?$/);
                            const text   = byMatch ? byMatch[1].trim() : line;
                            const author = byMatch ? byMatch[2].trim() : "";
                            const time   = byMatch ? byMatch[3] || "" : "";
                            const initials = author ? author.split(" ").map(w => w[0]).join("").slice(0,2).toUpperCase() : "?";
                            const colors = ["#3498db","#9b59b6","#1abc9c","#e67e22","#e74c3c","#2ecc71"];
                            const avatarColor = colors[initials.charCodeAt(0) % colors.length];
                            return (
                              <div key={idx} style={{ display: "flex", gap: 10, marginBottom: idx < lines.length - 1 ? 12 : 0 }}>
                                <div style={{ width: 32, height: 32, borderRadius: "50%", background: avatarColor, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: 700, flexShrink: 0, marginTop: 2 }}>
                                  {initials}
                                </div>
                                <div style={{ flex: 1 }}>
                                  <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "0 8px 8px 8px", padding: "8px 12px", fontSize: "13px", color: "#2d3748", lineHeight: 1.5, whiteSpace: "pre-line", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                                    {text.replace(/^\[[A-Za-z]+\][^|]*\|\s*/, "")}
                                  </div>
                                  <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: 3, paddingLeft: 2 }}>
                                    <span style={{ fontWeight: 600, color: "#64748b" }}>{author || (/^\[[A-Za-z]+\][^|]*\|/.test(text) ? "System · " + text.split("|")[0].replace(/[\[\]]/g, "").trim() : "Unknown")}</span>
                                    {time && <span style={{ marginLeft: 6 }}>{time}</span>}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    );
                  })()}

                  {/* New Comment Input */}
                  <div style={{ background: "#fff", padding: "14px 16px 10px" }}>
                    <div style={{ fontSize: "11px", fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 8 }}>Add New Comment</div>
                    <textarea
                      value={this.state.newComment || ""}
                      onChange={(e) => this.setState({ newComment: e.target.value })}
                      placeholder="Type your observation, finding or note here…"
                      maxLength={300}
                      rows={3}
                      style={{ width: "100%", fontSize: "13px", color: "#2d3748", border: "1px solid #cbd5e0", borderRadius: 6, padding: "10px 12px", resize: "none", outline: "none", fontFamily: "inherit", lineHeight: 1.6, transition: "border-color 0.2s" }}
                      onFocus={e => e.target.style.borderColor = "#4299e1"}
                      onBlur={e => e.target.style.borderColor = "#cbd5e0"}
                    />
                    <div style={{ textAlign: "right", fontSize: "11px", color: (this.state.newComment || "").length > 250 ? "#e74c3c" : "#94a3b8", marginTop: 3 }}>
                      {(this.state.newComment || "").length}/300
                    </div>
                  </div>

                  {/* Footer */}
                  <div style={{ padding: "8px 16px 14px", background: "#fff", display: "flex", justifyContent: "flex-end", gap: 8, borderTop: "1px solid #f0f0f0" }}>
                    <button type="button" data-dismiss="modal" className="closePopup"
                      style={{ padding: "7px 20px", fontSize: "13px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, color: "#555", cursor: "pointer", fontWeight: 500 }}>
                      Cancel
                    </button>
                    <button id={this.state.userid} type="button" onClick={this.submitComment}
                      disabled={!(this.state.newComment || "").trim()}
                      style={{ padding: "7px 22px", fontSize: "13px", background: (this.state.newComment || "").trim() ? "#1e8449" : "#a8d5b5", border: "none", borderRadius: 6, color: "#fff", fontWeight: 700, cursor: (this.state.newComment || "").trim() ? "pointer" : "not-allowed", transition: "background 0.2s" }}>
                      ✓ Add Comment
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {this.state.verifiertype === "8" && (
              <div
                id="progressinfomodal"
                className="modal fade"
                role="dialog"
                aria-labelledby="commentModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button
                        onClick={this.resetInfoModal.bind(this)}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <h4
                        className="modal-title text-center"
                        id="commentModalLabel"
                      >
                        Verifier Progress
                      </h4>
                    </div>

                    <div className="modal-body">
                      {this.state.selectedVerifiers &&
                        this.state.selectedVerifiers.map((verifier, index) => {
                          // Find matching efficiency data, ensure selectedVerifiersEfficency is defined
                          const efficiencyData =
                            (this.state.selectedVerifiersEfficency &&
                              this.state.selectedVerifiersEfficency.find(
                                (eff) => eff.label === verifier.value
                              )) ||
                            {}; // Fallback to empty object if not found

                          // Extract efficiency value and average time per ECG
                          const efficiencyValue = efficiencyData.value || 0;
                          const averageTimePerECG =
                            efficiencyData.averageTimePerECG || "N/A";
                          const hourstocompleted =
                            efficiencyData.hourstocompleted;

                          // Function to format date and time
                          const formatDateTime = (isoDateTime) => {
                            if (
                              !isoDateTime ||
                              isNaN(Date.parse(isoDateTime))
                            ) {
                              return "N/A"; // Return "N/A" if input is invalid
                            }

                            // Convert ISO string to Date object
                            const date = new Date(isoDateTime);

                            // Adjust time for IST (+5:30)
                            date.setMinutes(date.getMinutes());

                            // Format the date and time components
                            const formattedDate =
                              date.toLocaleDateString("en-IN"); // Indian locale
                            const formattedTime = date.toLocaleTimeString(
                              "en-IN",
                              {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true, // Use 12-hour format with AM/PM
                              }
                            );

                            return `${formattedDate || "NA"} ${
                              formattedTime || "NA"
                            }`;
                          };

                          // Format start time and end time
                          const startTime =
                            formatDateTime(efficiencyData.startTime) || "N/A";
                          const endTime =
                            formatDateTime(efficiencyData.endTime) || "N/A";

                          // Determine progress bar color based on efficiency value
                          let progressColor = "low-efficency"; // Default to red for 0-40
                          if (efficiencyValue >= 81 && efficiencyValue <= 100) {
                            progressColor = "high-efficency"; // Green for 81-100
                          } else if (
                            efficiencyValue >= 71 &&
                            efficiencyValue <= 80
                          ) {
                            progressColor = "average-efficency"; // Light Green for 71-80
                          } else if (
                            efficiencyValue >= 41 &&
                            efficiencyValue <= 70
                          ) {
                            progressColor = "medium-efficency"; // Yellow for 41-70
                          }

                          return (
                            <div
                              key={index}
                              className="d-flex align-items-center mb-3"
                            >
                              <div
                                className="flex-grow-1"
                                style={{ color: "black" }}
                              >
                                {verifier.label}: {startTime} - {endTime}
                              </div>
                              <div
                                className="flex-grow-1"
                                style={{ color: "black" }}
                              >
                                Total Time Analaysed:
                                {efficiencyData.totalSpendHours} (
                                {efficiencyData.totalEfficientCount})
                              </div>
                              <div
                                className="progress"
                                style={{ width: "60%", height: "17px" }}
                              >
                                <div
                                  className={`progress-bar ${progressColor}`}
                                  role="progressbar"
                                  style={{
                                    width: `${efficiencyValue}%`,
                                  }}
                                  aria-valuenow={efficiencyValue}
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                >
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      marginTop: "-2%",
                                    }}
                                  >
                                    {efficiencyValue}% - {averageTimePerECG} Min
                                  </p>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>

                    <div className="modal-footer">
                      <div>
                        <p style={{ color: "black", display: "flex" }}>
                          Time to Deliver Report: {this.state.hourstocompleted}
                        </p>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-6 multi-horizontal"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div
              id="editInfoModal"
              className="modal fade"
              role="dialog"
              data-backdrop="static"
              data-keyboard="false"
            >
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header" style={{ background: "#24333e", padding: "10px 16px", borderRadius: "6px 6px 0 0" }}>
                    <button type="button" className="close" data-dismiss="modal" onClick={this.resetInfoModal.bind(this)} style={{ color: "#fff", opacity: 0.8, marginTop: 0 }}>
                      &times;
                    </button>
                    <h4 className="modal-title" style={{ color: "#fff", fontSize: "15px", fontWeight: 600 }}>
                      ✏️ Edit Patient
                      {this.state.patient_name ? <span style={{ fontWeight: 400, fontSize: "13px", marginLeft: 8, opacity: 0.75 }}>— {this.state.patient_name}</span> : ""}
                    </h4>
                  </div>

                  <form method="post" onSubmit={this.onSubmitInfo}>
                    <div className="modal-body" style={{ position: "relative", padding: "16px 20px", fontSize: "13px" }}>
                      {/* Loading overlay */}
                      {this.state.loadingEditModal && (
                        <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(255,255,255,0.8)", zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <div style={{ width: 40, height: 40, border: "5px solid #f3f3f3", borderTop: "5px solid #3498db", borderRadius: "50%", animation: "spin 0.8s linear infinite" }}></div>
                          <style>{`@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}`}</style>
                        </div>
                      )}

                      {/* ── SECTION: Patient Info ── */}
                      <div style={{ background: "#f8f9fa", borderRadius: "6px", padding: "10px 14px", marginBottom: "10px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Patient Info</div>
                        <div className="row" style={{ marginBottom: 0 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Name</label>
                              <input type="text" className="form-control input-sm" name="patient_name" onChange={this.onChange} value={this.state.patient_name} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Email</label>
                              <input type="text" className="form-control input-sm" name="email_id" onChange={this.onChange} value={this.state.email_id} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Phone</label>
                              <input type="text" className="form-control input-sm" name="phone" onChange={this.onChange} value={this.state.phone} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginBottom: 0 }}>
                          <div className="col-md-5" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Hospital</label>
                              <input type="text" className="form-control input-sm" name="hospital" onChange={this.onChange} value={this.state.hospital} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-5" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Doctor</label>
                              <Select
                                options={options}
                                value={selectedDoctor}
                                onChange={this.handleDoctorChange}
                                placeholder="Search Doctor"
                                classNamePrefix="react-select"
                                styles={{
                                  control: (base) => ({ ...base, minHeight: 30, height: 30, fontSize: "13px", borderColor: errors.doctor_id ? "red" : base.borderColor }),
                                  valueContainer: (base) => ({ ...base, padding: "0 6px" }),
                                  indicatorsContainer: (base) => ({ ...base, height: 30 }),
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>IP/OP</label>
                              <input type="text" className="form-control input-sm" onChange={this.onIpOpChange} value={this.state.ipop} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ── SECTION: Clinical Settings ── */}
                      <div style={{ background: "#f8f9fa", borderRadius: "6px", padding: "10px 14px", marginBottom: "10px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Clinical Settings</div>

                        {/* Row: File Type + Priority + Report Status */}
                        <div className="row" style={{ marginBottom: 4 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>File Type</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["easy","moderate","hard"].map(ft => (
                                <button key={ft} type="button"
                                  onClick={() => this.handleTypeChange({ target: { value: ft } })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.filetype === ft ? "#24333e" : "#fff", color: this.state.filetype === ft ? "#fff" : "#333", cursor: "pointer", textTransform: "capitalize", borderRadius: ft === "easy" ? "4px 0 0 4px" : ft === "hard" ? "0 4px 4px 0" : "0" }}
                                >{ft.charAt(0).toUpperCase() + ft.slice(1)}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Priority</label>
                            <div style={{ display: "flex", gap: "4px", width: "100%" }}>
                              {[
                                { v: "1", label: "High",     color: "#e74c3c", bg: "rgba(231,76,60,0.12)"  },
                                { v: "2", label: "Moderate", color: "#f39c12", bg: "rgba(243,156,18,0.12)" },
                                { v: "3", label: "Simple",   color: "#3498db", bg: "rgba(52,152,219,0.12)" },
                                { v: "4", label: "Normal",   color: "#27ae60", bg: "rgba(39,174,96,0.12)"  },
                              ].map((p) => {
                                const active = String(this.state.priority) === p.v;
                                return (
                                  <button key={p.v} type="button"
                                    onClick={() => this.onPriorityChange({ target: { value: p.v } })}
                                    style={{ flex: 1, padding: "5px 2px", fontSize: "11px", fontWeight: 700, border: `1px solid ${active ? p.color : "#ccc"}`, background: active ? p.bg : "#fff", color: active ? p.color : "#777", cursor: "pointer", borderRadius: "4px", transition: "all 0.15s" }}
                                  >{p.label}</button>
                                );
                              })}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Report Status</label>
                            <select className="form-control input-sm" value={this.state.reportstatus} onChange={this.onReportStatuschange} style={{ height: 30, fontSize: "12px", padding: "2px 6px" }}>
                              <option value="0">Not Analyzed</option>
                              <option value="2">Analyze Started</option>
                              <option value="6">Analyze Completed</option>
                              <option value="3">Verification Completed</option>
                              <option value="4">In Preparation</option>
                              <option value="5">Report Completed</option>
                            </select>
                          </div>
                        </div>

                        {/* Row: Indication + Duration + Confirmation */}
                        <div className="row" style={{ marginTop: 8 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 6 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Indication</label>
                              <input type="text" className="form-control input-sm" name="indication" onChange={this.onChange} value={this.state.indication} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 6 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Monitoring Duration (Days)</label>
                              <input type="text" className="form-control input-sm" onChange={this.onDurationChange} value={this.state.duration} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Confirmation</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {[
                                { v: "Yes", color: "#27ae60" },
                                { v: "No",  color: "#e74c3c" },
                                { v: "Hold", color: "#f39c12" },
                                ...(livePatientsEnabled ? [{ v: "Live", color: "#8e44ad" }] : []),
                              ].map((item, i, arr) => (
                                <button key={item.v} type="button"
                                  onClick={() => {
                                    this.setState({ Confirmation: item.v, selectedConfirmation: item.v });
                                    axios.post(`${apiUrl}api/patients/updateConfirmation`, {
                                      userid: this.state.userid,
                                      Confirmation: item.v,
                                      // Source + identity of the actor (see
                                      // patient-list.js for the same pattern).
                                      ConfirmationSource: "staff",
                                      ConfirmedBy:
                                        localStorage.getItem("verifiername") || "Unknown staff",
                                      ConfirmedById:
                                        localStorage.getItem("verifierid") || null,
                                    }).catch(err => console.error("Confirmation update error:", err));
                                  }}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", fontWeight: 600, border: "1px solid #ccc", background: this.state.Confirmation === item.v ? item.color : "#fff", color: this.state.Confirmation === item.v ? "#fff" : "#555", cursor: "pointer", borderRadius: i === 0 ? "4px 0 0 4px" : i === arr.length - 1 ? "0 4px 4px 0" : "0" }}
                                >{item.v}</button>
                              ))}
                            </div>
                          </div>
                        </div>

                        {/* Row: Toggle buttons — Gender, AF, Cardiac, Pacemaker, Issue */}
                        <div className="row" style={{ marginTop: 8 }}>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Gender</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["M","F"].map(g => (
                                <button key={g} type="button"
                                  onClick={() => this.onGenderChange({ target: { value: g } })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "13px", fontWeight: 600, border: "1px solid #ccc", background: this.state.gender === g ? "#24333e" : "#fff", color: this.state.gender === g ? "#fff" : "#333", cursor: "pointer", borderRadius: g === "M" ? "4px 0 0 4px" : "0 4px 4px 0" }}
                                >{g}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Atrial Fib</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["yes","no"].map(v => (
                                <button key={v} type="button"
                                  onClick={() => this.setState({ af: v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.af === v ? (v === "yes" ? "#e74c3c" : "#27ae60") : "#fff", color: this.state.af === v ? "#fff" : "#333", cursor: "pointer", borderRadius: v === "yes" ? "4px 0 0 4px" : "0 4px 4px 0", textTransform: "capitalize" }}
                                >{v.charAt(0).toUpperCase() + v.slice(1)}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Cardiac Surg.</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["yes","no"].map(v => (
                                <button key={v} type="button"
                                  onClick={() => this.setState({ cardiac_surgery: v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.cardiac_surgery === v ? (v === "yes" ? "#e74c3c" : "#27ae60") : "#fff", color: this.state.cardiac_surgery === v ? "#fff" : "#333", cursor: "pointer", borderRadius: v === "yes" ? "4px 0 0 4px" : "0 4px 4px 0", textTransform: "capitalize" }}
                                >{v.charAt(0).toUpperCase() + v.slice(1)}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Pacemaker</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {[true,false].map(v => (
                                <button key={String(v)} type="button"
                                  onClick={() => this.setState({ pacemaker: v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.pacemaker === v ? (v ? "#e74c3c" : "#27ae60") : "#fff", color: this.state.pacemaker === v ? "#fff" : "#333", cursor: "pointer", borderRadius: v ? "4px 0 0 4px" : "0 4px 4px 0" }}
                                >{v ? "Yes" : "No"}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Issue Noticed</label>
                            <select className="form-control input-sm" value={this.state.issueReport} onChange={(e) => this.setState({ issueReport: e.target.value })} style={{ height: 30, fontSize: "12px", padding: "2px 6px" }}>
                              <option value="NA">None</option>
                              <option value="repeat">Repeat</option>
                              <option value="low_data">Low Data</option>
                              <option value="customer_reject">Customer Reject</option>
                              <option value="battery_issue">Battery Issue</option>
                              <option value="device_issue">Device Issue</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* ── SECTION: Support & Assignment ── */}
                      <div style={{ background: "#f8f9fa", borderRadius: "6px", padding: "10px 14px", marginBottom: "10px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Support & Assignment</div>
                        <div className="row" style={{ marginBottom: 6 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Support Person</label>
                              <select className="form-control input-sm" value={this.state.supportPerson} onChange={(e) => this.setState({ supportPerson: e.target.value })} style={{ height: 30, fontSize: "12px", padding: "2px 6px" }}>
                                <option value="">— None —</option>
                                {(Array.isArray(this.state.verifiers) ? this.state.verifiers : []).map((v) => (
                                  <option key={v.value} value={v.value}>{v.label}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-8">
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Support Notes</label>
                              <textarea className="form-control" rows="2" value={this.state.supportedMatter} onChange={(e) => this.setState({ supportedMatter: e.target.value })} placeholder="Enter details..." style={{ fontSize: "13px", resize: "none" }} />
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginBottom: 6 }}>
                          <div className="col-md-12">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 2, display: "block" }}>Assign Verifier</label>
                            <Select
                              isMulti
                              options={this.state.verifiers}
                              value={this.state.selectedVerifiers}
                              onChange={this.handleVerifierChange}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              placeholder="Select verifiers..."
                              menuPlacement="auto"
                              maxMenuHeight={140}
                              styles={{
                                control: (base) => ({ ...base, fontSize: "12px", minHeight: 28, maxHeight: 60, overflowY: "auto" }),
                                valueContainer: (base) => ({ ...base, padding: "2px 6px", flexWrap: "wrap", maxHeight: 54, overflowY: "auto" }),
                                indicatorsContainer: (base) => ({ ...base, height: 28, alignSelf: "flex-start" }),
                                option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#24333e" : state.isFocused ? "#e5e5e5" : null, color: state.isSelected ? "white" : "black", fontSize: "12px", padding: "4px 10px" }),
                                multiValue: (provided) => ({ ...provided, backgroundColor: "#24333e", margin: "1px 2px" }),
                                multiValueLabel: (provided) => ({ ...provided, color: "white", fontSize: "11px", padding: "1px 4px" }),
                                multiValueRemove: (provided) => ({ ...provided, color: "white", padding: "0 3px" }),
                              }}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Clinical Condition</label>
                              <textarea className="form-control" rows="2" value={this.state.clinicalCondition} onChange={(e) => this.setState({ clinicalCondition: e.target.value })} placeholder="Enter clinical condition..." style={{ fontSize: "13px", resize: "none" }} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer" style={{ padding: "10px 16px", display: "flex", justifyContent: "flex-end", gap: 8 }}>
                      <button type="button" className="btn closePopup" data-dismiss="modal" style={{ padding: "6px 20px", fontSize: "13px", background: "#f0f0f0", border: "1px solid #ccc", borderRadius: 4, color: "#444" }}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-success" disabled={this.state.loadingEditModal} style={{ padding: "6px 24px", fontSize: "13px", background: "#27ae60", border: "none", borderRadius: 4, color: "#fff", fontWeight: 600 }}>
                        {this.state.loadingEditModal ? "Saving…" : "✓ Save Changes"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {this.state.isConfirmationModalOpen && (
              <div
                id="ConfirmInfoModal"
                className="modal fade in"
                style={{ display: "block" }}
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        onClick={this.handleConfirmationCancel}
                      >
                        &times;
                      </button>
                      <h4 className="modal-title text-center">
                        Confirmation Status
                      </h4>
                    </div>
                    <div className="modal-body">
                      <div className="form-group">
                        <label
                          className="form-control-label mbr-fonts-style display-7"
                          style={{ color: "Black" }}
                        >
                          Select Status
                        </label>
                        <select
                          className="form-control"
                          value={this.state.selectedConfirmation}
                          onChange={this.handleConfirmationChange}
                        >
                          <option value="">Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                          <option value="Hold">Hold</option>
                        {livePatientsEnabled && <option value="Live">Live</option>}
                        </select>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-success"
                        data-dismiss="modal"
                        onClick={this.handleConfirmationSubmit}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-default"
                        data-dismiss="modal"
                        onClick={this.handleConfirmationCancel}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="row" style={{ margin: 0 }}>
              <div className="col-sm-12" style={{ padding: "0 8px" }}>
                <div style={{ background: "#072224", borderRadius: "6px", overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.25)" }}>

                  {/* ── Compact toolbar: title + count badge + search ── */}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", background: "#0c2e32", borderBottom: "2px solid #1e6b72" }}>
                    <span style={{ color: "#ffffff", fontWeight: 700, fontSize: "14px", letterSpacing: "0.4px" }}>
                      ⏸️ Patient Hold
                      {filteredRows && filteredRows.length > 0 && (
                        <span style={{ marginLeft: 8, fontSize: "11px", fontWeight: 600, color: "#ffffff", background: "#1a6a72", borderRadius: 10, padding: "2px 10px", border: "1px solid #2a9aaa" }}>
                          {filteredRows.length} shown
                        </span>
                      )}
                    </span>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                        <span style={{ position: "absolute", left: 9, color: "#2eaabb", fontSize: "14px", pointerEvents: "none" }}>🔍</span>
                        <input
                          type="text"
                          placeholder="Search patient, doctor…"
                          style={{ height: 34, paddingLeft: 30, paddingRight: 10, fontSize: "12px", borderRadius: 6, border: "2px solid #2eaabb", background: "#0f4a52", color: "#ffffff", outline: "none", width: 215, fontWeight: 500, boxShadow: "0 0 0 1px rgba(46,170,187,0.3)" }}
                          value={this.state.searchQuery}
                          onChange={this.handleSearchChange}
                        />
                      </div>
                    </div>
                  </div>

                  {/* ── Table — column structure mirrors patient-list ── */}
                  <div style={{ padding: "0", overflowX: "auto" }}>
                    <table
                      className="table table-striped"
                      style={{ width: "100%", marginBottom: 0, tableLayout: "fixed" }}
                    >
                      <colgroup>
                        <col style={{ width: "4%" }} />     {/* SL */}
                        <col style={{ width: "13%" }} />    {/* PATIENT (id + name stacked) */}
                        <col style={{ width: "10%" }} />    {/* ADDED DATE */}
                        <col style={{ width: "12%" }} />    {/* DISTRIBUTOR */}
                        <col style={{ width: "13%" }} />    {/* DOCTOR */}
                        <col style={{ width: "22%" }} />    {/* ACTION */}
                        {this.state.verifiertype === "8" && (
                          <col style={{ width: "16%" }} />  /* REPORT */
                        )}
                        <col style={{ width: "10%" }} />    {/* MONITORING */}
                      </colgroup>
                      <thead>
                        <tr style={{ background: "#031213" }}>
                          {this.state.columns.map((col, index) => (
                            <th
                              key={index}
                              style={{
                                padding: "7px 8px",
                                textAlign: "center",
                                color: "#89a8c0",
                                fontWeight: 600,
                                fontSize: "11px",
                                textTransform: "uppercase",
                                letterSpacing: "0.6px",
                                borderBottom: "2px solid #0c2e30",
                                borderTop: "none",
                              }}
                            >
                              {col.label}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {filteredRows.map((row, rowIndex) => {
                          const cellStyle = {
                            verticalAlign: "middle",
                            textAlign: "center",
                            wordBreak: "break-word",
                            padding: "8px 6px",
                          };
                          return (
                            <tr key={rowIndex}>
                              <td style={cellStyle}>{rowIndex + 1}</td>
                              {/* PATIENT — id (bold) + name (lighter) stacked, like patient-list */}
                              <td
                                onClick={this.handleRowClick}
                                style={{ ...cellStyle, cursor: "pointer" }}
                              >
                                <div style={{ fontWeight: 700, fontSize: "13px", lineHeight: 1.3 }}>{row.patientId}</div>
                                <div style={{ fontSize: "12px", fontWeight: 500, opacity: 0.85, marginTop: "2px" }}>{row.name}</div>
                              </td>
                              <td onClick={this.handleRowClick} style={{ ...cellStyle, cursor: "pointer" }}>{row.added_date}</td>
                              <td style={cellStyle}>{row.distributor}</td>
                              <td style={cellStyle}>{row.doctor_name}</td>
                              <td style={cellStyle}>{row.action}</td>
                              {this.state.verifiertype === "8" && <td style={cellStyle}>{row.report}</td>}
                              <td style={cellStyle}>{row.monitoring_duration}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Patienthold;
